import { store } from '../data/store';

/** /<slug>/event/<id> or /event/<id>: the event routes (src/App.tsx). */
const EVENT_PATH = /^\/(?:[^/?#]+\/)?event\/([A-Za-z0-9_-]+)\/?(?:[?#]|$)/;

/**
 * A plain click on a link to an event page starts fetching that event's full row at once (its id
 * bucket, else the edge API: store.ensureEvent) while React renders the new page. The page's own
 * request used to leave only after that render, ~150-190 ms later on a throttled phone
 * (2026-10-19). It is the very request the page makes: the store hands the page this one, and a
 * row it already has costs nothing. Capture phase, so it runs before the router's own handler; no
 * fetch for a click that does not open the link in this tab (a modifier key, another target).
 * main.tsx installs it once the app is mounting, so a tap on a page whose JavaScript is still on
 * its way stays a plain page load.
 */
export const startEventClicks = () => {
  document.addEventListener(
    'click',
    (e) => {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = (e.target as Element | null)?.closest?.('a[href]') as HTMLAnchorElement | null;
      if (!a || (a.target && a.target !== '_self')) return;
      const m = EVENT_PATH.exec(a.getAttribute('href') ?? '');
      if (m) void store.ensureEvent(m[1]);
    },
    true
  );
};
